import React from "react";
import Button from "@amzn/meridian/button";
import "./Footer.scss";

export interface FooterProps {
  /**
   * Optional: pages that pass `showClearOverrides={false}` (the read-only review
   * step) have no handler to give, and shouldn't have to invent an empty one.
   */
  onClearOverrides?: () => void;
  onNext: () => void;
  lastModified?: string;
  showClearOverrides?: boolean;
  nextButtonDisplay?: string;
  /**
   * Where the action bar sits on the page. The same actions are rendered at the
   * top of the longer workflow pages so operators don't have to scroll to the
   * bottom to hit Next / Publish. Only the surrounding chrome (border, margins)
   * differs between the two.
   */
  position?: "bottom" | "top";
  /** Disables both actions, e.g. while a publish request is in flight. */
  disabled?: boolean;
}

/**
 * Reusable action bar with Clear overrides and Next buttons.
 * Rendered at the bottom by default, and optionally duplicated at the top of
 * the page via `position="top"`.
 */
const Footer: React.FC<FooterProps> = ({
  onClearOverrides,
  onNext,
  lastModified,
  nextButtonDisplay,
  showClearOverrides = true,
  position = "bottom",
  disabled = false,
}) => {
  return (
    <div className={`footer ${position === "top" ? "footer--top" : ""}`}>
      {lastModified && <div className="last-modified">{lastModified}</div>}
      <div className="actions">
        {showClearOverrides && (
          <Button onClick={onClearOverrides} disabled={disabled}>
            Clear overrides
          </Button>
        )}
        <Button onClick={onNext} disabled={disabled}>
          {nextButtonDisplay || "Next"}
        </Button>
      </div>
    </div>
  );
};

export default Footer;
